import React from "react";
import './index.css';
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import Input from "../../../Components/Control/Input";
import {connect} from "react-redux";
import Resource from "../../../Resource";
import PropTypes from 'prop-types';
import {Tool} from "../../../App";
import Notif from "../../../Components/Notif";
import Configuration from "../../../Server/Configuration";
import Separator from "../../../Components/Control/Separator";
import Label from "../../../Components/Control/Label";
import MyComponent from '../../../Components/MyComponent';

class ModalRole extends MyComponent {
    constructor (props) {
        super(props);

        props.refer.current = this;

        this.state = {
            title: {
                INSERT: 'افزودن نقش',
                UPDATE: 'ویرایش نقش',
                VIEW: 'اطلاعات نقش'
            },
            fields: {
                actionList: []
            },
            error: false,
            accessList: null
        };

        this.ref = {
            modal: React.createRef(),
            insert: React.createRef(),
            update: React.createRef(),
            close: React.createRef(),
            roleName: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current:null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {
        roleName: x => Boolean(x) || 'نام نقش وارد نشده است.'
    };

    shouldComponentUpdate (nextProps, nextState, nextContext) {
        const {state} = this;

        return state.action !== nextState.action ||
            state.error !== nextState.error ||
            state.fields !== nextState.fields ||
            state.accessList !== nextState.accessList;
    }

    componentDidMount () {
        Configuration.accessList()
            .then(list => {
                console.log(list);
                this.setState({accessList: list});
            });
    }

    render () {
        const {state} = this;
        let readOnly = state.action === ModalAction.VIEW;

        return <Modal ref={this.ref.modal}
                      name={'ModalRole'}
                      size={'large'}
                      title={state.title[state.action]}
                      error={state.error}>
            <ModalContent>
                <div className={'dis-f'}>
                    <Input ref={this.ref.roleName} value={state.fields?.roleName} className={'pad-4 fb-20'} label={'نام نقش'} readOnly={readOnly} validation={this.validations.roleName} onChange={this.setField.bind(this, 'roleName')}/>
                    {state.accessList ? state.accessList.map((item, index) => {
                        return <React.Fragment key={index}>
                            {index !== 0 && <Separator/>}
                            <Label>{item.menuStr}</Label>
                            <div className={'dis-f fb-20'} style={{justifyContent: 'flex-start'}}>
                                {item.menuActions.map((item, index) => {
                                    const access = state.fields?.actionList.includes(item.menuActionId);
                                    return <button key={index} className={access ? 'access granted' : 'access denied'} onClick={this.setField.bind(this, 'actionList', item.menuActionId)}>{item.menuActionStr}</button>;
                                })}
                            </div>
                        </React.Fragment>;
                    }) : null}
                </div>
            </ModalContent>
            <ModalControls>
                {state.action === ModalAction.INSERT && <Button refer={this.ref.insert} className={'mar-4'} theme={'blue'} onClick={this.insertClickHandler.bind(this)}>افزودن نقش</Button>}
                {state.action === ModalAction.UPDATE && <Button refer={this.ref.update} className={'mar-4'} theme={'yellow'} onClick={this.updateClickHandler.bind(this)}>ویرایش نقش</Button>}
                <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
            </ModalControls>
        </Modal>;
    }

    setField (key, value) {
        const fields = {...this.state.fields};

        switch (key) {
            case 'actionList':
                const index = fields.actionList.findIndex(item => item === value);

                if (index === -1) {
                    fields.actionList.push(value);
                } else {
                    fields.actionList.splice(index, 1);
                }
                break;
            default:
                fields[key] = value;
        }

        this.setState({fields});
    }

    insertClickHandler () {
        const {ref, state} = this;

        if (this.validate()) {
            ref.insert.current.loading();
            this.setState({error: null});

            Configuration.addRole({
                roleName: state.fields?.roleName,
                actionList: state.fields?.actionList || []
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.INSERT_SUCCESSFUL).show();

                ref.insert.current.loading(false);
                this.close(true);
            }).catch(message => {
                ref.insert.current.loading(false);

                this.setState({error: message});
            });
        }
    }

    updateClickHandler () {
        const {ref, state} = this;

        if (this.validate()) {
            ref.update.current.loading();
            this.setState({error: null});

            Configuration.updateRole({
                roleId: state.fields?.roleId,
                roleName: state.fields?.roleName,
                actionList: state.fields?.actionList || []
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.UPDATE_SUCCESSFUL).show();

                ref.update.current.loading(false);
                this.close(true);
            }).catch(message => {
                ref.update.current.loading(false);

                this.setState({error: message});
            });
        }
    }

    open (data, action) {
        if (action === ModalAction.INSERT) {
            this.setState({
                data,
                action,
                fields: {
                    actionList: []
                },
                error: null
            });
        } else if ([ModalAction.VIEW, ModalAction.UPDATE].includes(action)) {
            const actionList = [];
            for (let item of data.menues) {
                actionList.push(...item.menuActions.map(item => item.menuActionId));
            }

            this.setState({
                data,
                action,
                fields: {
                    roleId: data?.roleId,
                    roleName: data?.roleStr,
                    actionList
                },
                error: null
            });
        }

        return this.ref.modal.current.open();
    }

    close (success) {
        this.ref.modal.current.close();

        if (success === true)
            this.props.onSuccess();

        this.props.onClose();
    }

    validate () {
        const validate = Tool.validate(this.ref.roleName);

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base,
        user: state.user
    };
};

export default connect(mapStateToProps)(ModalRole);